import React from 'react';
import Header from './Header.js';

export default function Help() {
  return (
    <>
      <Header title="Help" location="/help" />
      <div className="card mb-4">
        <h5>Additional Resources</h5>
        <ul>
          <li>Questions, bug reports, feature requests? Email or Slack Dhruv Patel (dhrpatel).</li>
          <li>Want to contribute or just look at the source code? The code is hosted on <a href="https://github.com/twilio-internal/blogalytics-v2">GitHub</a>. Email or Slack Dhruv Patel to request access.</li>
        </ul>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="mb-3">Blogalytics Metrics FAQ</h4>
          <h5>Article Tracking</h5>
          <ul>
            <li><b>Why don't I see my recently published article?</b><br />
              Articles appear in Blogalytics after their metadata page is generated, which happens every <b>Saturday</b>. If your article was published mid-week, it will show up the following Saturday.
            </li>
            <li><b>Why are some articles missing from Blogalytics?</b><br />
              Blogalytics only tracks articles that have an active metadata page (<code>.md</code> file). This ensures we're tracking live, accessible content rather than:
              <ul>
                <li>Redirected or archived articles</li>
                <li>Unpublished drafts</li>
                <li>Deleted or restricted pages</li>
              </ul>
            </li>
            <li><b>What about redirected articles?</b><br />
              When an article's URL changes, Google Analytics may show traffic to both the old and new paths. Blogalytics only imports the <b>current active path</b> (the one with a metadata page), preventing duplicate entries and ensuring accurate totals.
            </li>
          </ul>

          <h5>Metadata & Tagging</h5>
          <ul>
            <li><b>How are authors, products, and programming languages assigned?</b><br />
              This information comes directly from <b>AEM tags</b>. If an article isn't properly tagged in AEM, it may appear with missing or incorrect metadata in Blogalytics.
            </li>
            <li><b>I don't see my team assignment. How do I add it?</b><br />
              If your articles don't show the correct team, you can add your author-to-team mapping in the <a href="https://docs.google.com/spreadsheets/d/17uo6EQWO6ikNRC0ZPoZAqhvvQedZEF-Iqco98rr2aAo/edit?gid=0#gid=0" target="_blank" rel="noopener noreferrer">Blogalytics Metadata Spreadsheet</a>. The system syncs with this spreadsheet <b>weekly (every Monday)</b>, so your team assignment will appear within a week of adding it.
            </li>
          </ul>

          <h5>Metrics Accuracy</h5>
          <ul>
            <li><b>How do Blogalytics metrics compare to Looker Studio?</b><br />
              <ul>
                <li><b>Looker Studio</b>: Filters out bot and malicious traffic → more accurate individual numbers</li>
                <li><b>Blogalytics</b>: Includes all traffic → numbers are typically <b>2-5% higher</b></li>
              </ul>
            </li>
            <li><b>Should I use Blogalytics for exact metrics?</b><br />
              No. Blogalytics is designed for:
              <ul>
                <li><b>Quick comparisons</b> between articles</li>
                <li><b>Spotting trends</b> over time</li>
                <li><b>Identifying content gaps</b></li>
                <li><b>Relative performance</b> analysis</li>
              </ul>
              For precise metrics and official reporting, use <b>Looker Studio</b>.
            </li>
          </ul>
          <h5>Need Help?</h5>
          <p>If you notice missing articles, incorrect metadata, or have questions about the metrics, reach out to Dhruv Patel (dhrpatel).</p>
        </div>
      </div>
    </>
  );
}